module.exports = __webpack_public_path__ + "static/media/bottom-pattern.dd19402b.svg";